import axios from 'axios'
const { getBaseApiURL } = require('./helpers/baseurl')

export const baseURL = getBaseApiURL()

export default axios.create({
  baseURL: baseURL
});

